// extracted by mini-css-extract-plugin
export default {"wrap":"style_wrap__fvivS","header":"style_header__bXlJn","body":"style_body__DFdBq","selected-menu":"style_selected-menu__28MSf","menu-tip":"style_menu-tip__X70da"};